import { Component, Input } from '@angular/core';
import { ElementData } from '@app/core/models/courses.model';

@Component({
  selector: 'app-audio-card',
  templateUrl: './audio-card.component.html',
  styles: [],
  standalone: false,
})
export class AudioCardComponent {
  @Input() public element: ElementData;
  @Input() public fullWidth = false;
  @Input() public fullSize = false;
  @Input() public paddingBottom = false;
}
